export class UserModel {
  id: number;
  name: string;
  email: string;
  photoUrl: string;
  endDate?: string;
  startMonthDay: number;
}
